export default __webpack_public_path__ + "static/media/talent.3b03835d.svg";